export function isExtensionSupported(ext: string) {
  return ext === "pdf";
}
